<script lang="ts">
	import type { Attachment } from '@andresot/protocol';
	import { Icon } from '@andresot/ui';
	import { ui } from '$stores/ui.svelte';
	import { formatFileSize } from '$utils/format';
	import UploadRing from './UploadRing.svelte';
	let {
		media,
		uploads,
		onopen
	}: {
		media: Attachment[];
		uploads?: Record<string, number>;
		onopen?: (item: Attachment) => void;
	} = $props();
	let tiles = $derived(media.slice(0, 4));
	function open(item: Attachment) {
		if (onopen) onopen(item);
		else
			ui.openLightbox(
				media.map((attachment) => ({ attachment })),
				Math.max(
					0,
					media.findIndex((a) => a.id === item.id)
				)
			);
	}
</script>

{#if media.length === 1 && media[0]?.kind === 'video'}
	<video
		class="single"
		src={media[0].url}
		poster={media[0].previewUrl}
		controls
		preload="metadata"
		playsinline><track kind="captions" /></video
	>
{:else if media.length}
	<div class="album" data-count={tiles.length} aria-label="Вложения сообщения">
		{#each tiles as item, position (item.id)}
			<button
				class="tile"
				class:video={item.kind === 'video'}
				style:aspect-ratio={media.length === 1
					? `${item.width ?? 4} / ${item.height ?? 3}`
					: undefined}
				onclick={(event) => {
					event.stopPropagation();
					open(item);
				}}
				aria-label="Открыть {item.name ?? (item.kind === 'video' ? 'видео' : 'изображение')}"
			>
				{#if item.previewUrl || (item.kind === 'image' && item.url)}
					<img src={item.previewUrl ?? item.url} alt={item.name ?? ''} loading="lazy" />
				{:else}<span class="empty"><Icon name="image" size={24} /></span>{/if}
				{#if item.kind === 'video'}<span class="play" aria-hidden="true"
						><Icon name="play" size={22} /></span
					>{/if}
				{#if media.length > tiles.length && position === tiles.length - 1}<span class="more"
						>+{media.length - tiles.length}</span
					>{/if}
				{#if uploads?.[item.id] !== undefined}
					<span class="upload"
						><UploadRing ratio={uploads[item.id] ?? 0} />{#if item.size}<small
								>{formatFileSize(Math.round(item.size * (uploads[item.id] ?? 0)))} / {formatFileSize(
									item.size
								)}</small
							>{/if}</span
					>
				{/if}
			</button>
		{/each}
	</div>
{/if}

<style>
	.album {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: var(--spacing-2xs);
		width: 100%;
		max-width: 420px;
		margin-bottom: var(--spacing-s);
		overflow: hidden;
		border-radius: var(--radius-m);
	}
	.album[data-count='1'] {
		grid-template-columns: 1fr;
	}
	.album[data-count='3'] {
		grid-template-columns: 2fr 1fr;
		grid-template-rows: 1fr 1fr;
	}
	.album[data-count='3'] .tile:first-child {
		grid-row: span 2;
	}
	.tile {
		position: relative;
		display: block;
		padding: 0;
		border: 0;
		aspect-ratio: 1;
		background: var(--background-secondary);
		overflow: hidden;
		cursor: pointer;
	}
	.tile img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.empty,
	.play,
	.more,
	.upload {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.empty {
		color: var(--text-secondary);
	}
	.play,
	.more,
	.upload {
		color: var(--text-on-accent);
		background: var(--overlay-medium, rgba(0, 0, 0, 0.5));
	}
	.play {
		inset: auto;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: var(--radius-round);
		padding: var(--spacing-s);
	}
	.more {
		font: var(--text-title);
	}
	.upload {
		flex-direction: column;
		gap: var(--spacing-xs);
	}
	.single {
		display: block;
		width: 100%;
		max-height: 360px;
		margin-bottom: var(--spacing-s);
		border-radius: var(--radius-m);
	}
</style>
